export default "__VITE_ASSET__DpPZFn54__"